import React from "react";
import {
    Globe,
    Star,
    PhoneIncoming,
    Send,
    Search,
    Inbox,
    Phone,
} from "lucide-react";

export const SYSTEM_ICONS = {
    "functional-website": Globe,
    "5-star-review-funnel": Star,
    "missed-call-text-back": PhoneIncoming,
    "one-click-marketing-campaigns": Send,
    "local-seo": Search,
    "unified-inbox": Inbox,
    "business-phone": Phone,
};

export function SystemIcon({ slug, className = "w-5 h-5" }) {
    const Icon = SYSTEM_ICONS[slug];
    if (!Icon) return null;
    return <Icon className={className} aria-hidden="true" />;
}
